import TeamMember, { TeamMemberProps } from '@/components/elements/TeamMember';
import { SimpleGrid } from '@chakra-ui/react';

type Props = {
  members: TeamMemberProps[];
};

const TeamMemberSection = ({ members }: Props) => (
  <SimpleGrid
    className="boxed-container"
    as="section"
    px={[null, null, null, 20]}
    columns={[1, 2, null, 4]}
    spacing={14}
    alignItems="start"
  >
    {members.map((item) => (
      <TeamMember key={item.name} {...item} />
    ))}
  </SimpleGrid>
);

export default TeamMemberSection;
